import * as React from 'react';
import { useState } from 'react';
import { graphql } from 'gatsby';
import { useForm } from "react-hook-form";
import { callHook } from '../utils/utils';

export const BusinessCardReader = ({ slice, index }) => {
  const { title } = slice.primary;

  const [isImageSend, setImageSend] = useState(false);
  const [isEmailSend, setEmailSend] = useState(false);
  const [isError, setError] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [crms, setCRMs] = useState();
  //const [fileUrl, setFileUrl] = useState("")
  const [parsedData, setParsedData] = useState()
  const [editableData, setEditableData] = useState(parsedData || {});
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imgErrorMessage, setImgErrorMessage] = useState('');
  const [note, setNote] = useState();
  const [userEmail, setUserEmail] = useState();

  const acceptedFileTypes = [
    'pdf', 'jpg', 'gif', 'jpeg', 'bmp', 'tif', 'tiff', 'png'
  ];

  const { register, handleSubmit, formState: { errors, isSubmitted } } = useForm({
    mode: "onChange"
  });

  const isFirst = index === 0;

  if (typeof window !== 'undefined') {
    const pageUrl = window.location;
    //console.log('pageUrl: ', pageUrl);
  }

  const submitImage = async (data) => {
    const formData = new FormData();
    formData.append('file1', selectedFiles[0]);
    formData.append('file2', selectedFiles[1]);
    formData.append('route', 'img-upload');

    setLoading(true);
    try {
      const response = await fetch("https://n8n-do.yohn.io/webhook/bcr", {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      });

      if (response.ok) {
        const responseData = await response.json();
        console.log('responseData: ', responseData);
        if (responseData) {
          //setQrUrl(responseData.img);
          //setFileUrl(URL.createObjectURL(new Blob([responseData.vcf], { type: 'text/x-vcard;charset=utf-8' })))
          setParsedData(responseData.parsed_data)
          setEditableData(responseData.parsed_data)
          setNote(new Date().toLocaleString())
          setError(false);
        } else {
          setError(true);
        }
      } else {
        setError(true);
      }
    } catch (error) {
      setError(true);
    }
    setImageSend(true);
    setLoading(false);
  };

  let gclid = ""
  let msclkid = ""
  if (typeof window !== 'undefined'){
    const pageUrl = new URL(window.location);
    gclid = pageUrl.searchParams.get("gclid");
    //console.log('gclid: ', gclid);
    msclkid = pageUrl.searchParams.get("msclkid");
    //console.log('msclkid: ', msclkid);
  }

  const sentToEmail = async () => {
    setImageSend(false);
    const url = "https://n8n-do.yohn.io/webhook/bcr"

    const mode = "no-cors"
    let hookData = {route: "sent-to-email", email: userEmail}

    const person = {
      "firstName": editableData.firstName,
      "lastName": editableData.lastName,
      "email": editableData.email,
      "phone": editableData.phone,
      "address": editableData.address,
      "company": editableData.company,
      "title": editableData.title,
      "website": editableData.website,
      "note": note
    };

    const text = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:${editableData.lastName};${editableData.firstName}`,
      `FN:${editableData.firstName} ${editableData.lastName}`,
    ];

    if (editableData.email) {
      text.push(`EMAIL;TYPE=INTERNET:${editableData.email}`);
    }

    if (editableData.phone) {
      text.push(`TEL;CELL:${editableData.phone}`);
    }

    if (editableData.address) {
      text.push(`ADR:;;${editableData.address}`)
    }

    if (editableData.company) {
      text.push(`ORG:${editableData.company}`)
    }

    if (editableData.title) {
      text.push(`ORG:${editableData.title}`)
    }

    if (editableData.website) {
      text.push(`URL:${editableData.website}`)
    }

    if (note) {
      text.push(`NOTE:${note}`)
    }

    text.push("END:VCARD")

    const bcData = {
      "person": person,
      "vcard": text.join("\r\n")
    }

    hookData.bcData = bcData;
    window.scrollTo(0, 0)
    setLoading(true);
    const r = await callHook({url, params:hookData, mode});
    console.log('callHook r: ', r);
    if (r && r.success === true) {
      setError(false);
    } else {
      setError(true);
    }
    setEmailSend(true);
    setLoading(false);
  };

  const downloadVCF = async () => {
    //setImageSend(false);

    let text = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:${editableData.lastName};${editableData.firstName}`,
      `FN:${editableData.firstName} ${editableData.lastName}`,
    ];

    if (editableData.email) {
      text.push(`EMAIL;TYPE=INTERNET:${editableData.email}`);
    }

    if (editableData.phone) {
      text.push(`TEL;CELL:${editableData.phone}`);
    }

    if (editableData.address) {
      text.push(`ADR:;;${editableData.address}`)
    }

    if (editableData.company) {
      text.push(`ORG:${editableData.company}`)
    }

    if (editableData.title) {
      text.push(`ORG:${editableData.title}`)
    }

    if (editableData.website) {
      text.push(`URL:${editableData.website}`)
    }

    if (note) {
      text.push(`NOTE:${note}`)
    }

    text.push("END:VCARD")

    text = text.join("\r\n")

    //setFileUrl(URL.createObjectURL(new Blob([text], { type: 'text/x-vcard;charset=utf-8' })))

    const url = URL.createObjectURL(new Blob([text], { type: 'text/x-vcard;charset=utf-8' }))

    const link = document.createElement("a");
    link.href = url;
    link.download = `business-card.vcf`;
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  const getCRMs = async () => {
    setImageSend(false);
    const url = "https://n8n-do.yohn.io/webhook/bcr"

    const mode = "no-cors"
    let hookData = {route: "list-available-crms"}

    window.scrollTo(0, 0)
    setLoading(true);
    const r = await callHook({url, params:hookData, mode});
    console.log('callHook r: ', r);
    if (r.crms) {
      setError(false);
      setCRMs(r.crms)
    } else {
      setError(true);
    }
    setEmailSend(true);
    setLoading(false);
  };

  if (isLoading && !isImageSend && !isEmailSend) {
    return (
      <div className="py-6 bg-color-1">
        <div className="container">
          {isFirst ? <h1 className="h2 text-center mb-5">{title}</h1> : <h2 className="text-center mb-5">{title}</h2>}
          <div className="text-center">
            <div className="loader mx-auto"></div>
          </div>
        </div>
      </div>
    );
  }

  const icons = {
    phone: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16"><path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/></svg>,
    email: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-envelope-at" viewBox="0 0 16 16"><path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"/><path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z"/></svg>,
    company: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-building" viewBox="0 0 16 16"><path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z"/><path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1Zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3V1Z"/></svg>,
    address: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-house" viewBox="0 0 16 16"><path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/></svg>,
    website: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16"><path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z"/><path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z"/></svg>,
    upload: <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
  };

  const displayNames = {
    name: "Name",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    address: "Address",
    company: "Company",
    website: "Website",
    title: "Title"
  };

  const excludedKeys = ["firstName", "lastName"];
  //const fieldOrder = ["firstName", "lastName", "email", "phone", "company", "address", "website"];


  const handleInputChange = (key, value) => {
    setEditableData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const resetStates = () => {
    setImageSend(false)
    setEmailSend(false)
    /*setFileUrl(null),*/
    setSelectedFiles([])
    setCRMs([])
  };
  


  if (isImageSend) {
    return (
      <div className="py-6 bg-color-1">
        <div className="container">
          {isFirst ? <h1 className="h2 text-center mb-5">{title}</h1> : <h2 className="text-center mb-5">{title}</h2>}
          <div className="text-center">
            {!isError ?
              <div className="text-center">
                <div className="col-12 col-md-9 col-lg-7 mx-auto row align-items-center">
                  {(parsedData) ?
                    <>
                      <form onSubmit={handleSubmit(sentToEmail)} className="text-center col">
                        <div className="row">
                        {Object.entries(editableData).map(([key, value]) => (
                          key !== "note" && excludedKeys.includes(key) && value ? (
                            <div key={key} className={`col-12 col-lg-6`}>
                              <label className="w-100 text-start mb-2">
                                {/*icons[key] && <span className="me-2">{icons[key]}</span>*/}
                                <span className="h6 opacity-75">{`${displayNames[key] || key}: `}</span>
                                <input
                                  type="text"
                                  value={value || ""}
                                  onChange={(e) => handleInputChange(key, e.target.value)}
                                  className="form-control mt-1"
                                />
                              </label>
                            </div>
                          )
                          :
                          (
                            <div key={key} className={`col-12`}>
                              <label className="w-100 text-start mb-2">
                                {/*icons[key] && <span className="me-2">{icons[key]}</span>*/}
                                <span className="h6 opacity-75">{`${displayNames[key] || key}: `}</span>
                                <input
                                  type="text"
                                  value={value || ""}
                                  onChange={(e) => handleInputChange(key, e.target.value)}
                                  className="form-control mt-1"
                                />
                              </label>
                            </div>
                          )
                        ))}
                        </div>
                        <div className={`col-12`}>
                          <label className="w-100 text-start mb-2">
                            <span className="h6 opacity-75">{`Note: `}</span>
                            <textarea
                              value={note}
                              onChange={(e) => setNote(e.target.value)}
                              className="form-control mt-1"
                              rows="3"
                            />
                          </label>
                        </div>
                      </form>
                      <div className="mt-4 d-flex flex-column align-items-center justify-content-center gap-3">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary text-uppercase"
                          style={{width:"fit-content"}}
                          onClick={() => downloadVCF()}
                        >
                          {"Download contact"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary text-uppercase"
                          style={{width:"fit-content"}}
                          onClick={() => getCRMs()}
                        >
                          {"Add to my CRM"}
                        </button>
                        {!showEmailInput ? 
                          <button
                            type="button"
                            className="btn btn-sm btn-primary text-uppercase"
                            style={{width:"fit-content"}}
                            onClick={() => setShowEmailInput(true)}
                          >
                            {"Send to my email"}
                          </button>
                        :
                          <div className="w-100" style={{maxWidth:"400px"}}>
                            <div>
                              <label className="w-100 text-start mb-2">
                                <span className="h6 opacity-75">{`Enter your email: `}</span>
                                <input
                                  value={userEmail}
                                  onChange={(e) => setUserEmail(e.target.value)}
                                  className="form-control mt-1"
                                />
                              </label>
                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-primary text-uppercase mt-2"
                              style={{width:"fit-content"}}
                              onClick={sentToEmail}
                            >
                              {"Send to my email"}
                            </button>
                          </div>
                        }
                      </div>
                    </>
                  :
                    <p>{"Unfortunately, we couldn't scan your business card. Please upload a new photo, ensuring that your email address, first name, and last name are clearly visible."}</p>  
                  }
                </div>
              </div>
            :
              <div className="text-center">
                <h3>An error has occurred</h3>
                <p>Please try again later.</p>
              </div>
            }
            <button onClick={()=>{resetStates()}} className={"btn btn-sm text-uppercase btn-secondary mt-4"}>{"Back"}</button>
          </div>
        </div>
      </div>
    );
  }

  /*if (fileUrl != "") {
    return (
      <div className="py-6 bg-color-1">
        <div className="container">
          {isFirst ? <h1 className="h2 text-center mb-4">{title}</h1> : <h2 className="text-center mb-5">{title}</h2>}
          <div className="text-center">
            <div className="text-center">
              <a href={fileUrl} download="business-card.vcf">Download VCF</a>
            </div>
            <div className="mt-4">
              <button onClick={()=>{resetStates()}} className={"btn btn-sm text-uppercase btn-secondary"}>{"Try again"}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }*/

  if (Array.isArray(crms) && crms.length > 0) {
    return (
      <div className="py-6 bg-color-1">
        <div className="container">
          {isFirst ? <h1 className="h2 text-center mb-4">{title}</h1> : <h2 className="text-center mb-5">{title}</h2>}
          <div className="text-center col-12 col-md-9 col-lg-7 mx-auto">
            <h4 className="text-center">{"Available CRM integrations:"}</h4>
            <ul className="list-group mt-3 mx-auto" style={{width:"fit-content"}}>
              {crms.map((item, index) => (
                <li key={index} className="list-group-item">
                  {item}
                </li>
              ))}
            </ul>
            <div className="mt-4">
              <button onClick={()=>{resetStates()}} className={"btn btn-sm text-uppercase btn-primary"}>{"Try again"}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isEmailSend) {
    return (
      <div className="py-6 bg-color-1">
        <div className="container">
          {isFirst ? <h1 className="h2 text-center mb-4">{title}</h1> : <h2 className="text-center mb-5">{title}</h2>}
          <div className="text-center">
            {!isError ?
              <div className="text-center">
                <h4 className="text-center">{"The business card has been sent to your email."}</h4>
              </div>
            :
              <div className="text-center">
                <h3>An error has occurred</h3>
                <p>Please try again later.</p>
              </div>
            }
            <div className="mt-4">
              <button onClick={()=>{resetStates()}} className={"btn btn-sm text-uppercase btn-primary"}>{"Scan another card"}</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newFiles = [];
    let error = '';

    if (selectedFiles.length + files.length > 2) {
      setImgErrorMessage('You can only upload up to 2 files.');
      return;
    }

    files.forEach((file) => {
      const fileName = file.name;
      const fileExtension = fileName.split('.').pop().toLowerCase();

      if (acceptedFileTypes.includes(fileExtension)) {
        newFiles.push(file);
      } else {
        error = `File type not accepted: ${fileName}`;
      }
    });

    if (error) {
      setImgErrorMessage(error);
    } else {
      setImgErrorMessage('');
      setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleFileRemove = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <div className="py-6 bg-color-1">
      <style>
        {`.custom-file-upload {
            background-color:#ffffff;
            border: 1px solid #ccc;
            display: inline-block;
            padding: 12px 24px;
            cursor: pointer;
          }
          .custom-file-upload:hover {
            background-color:#ffffff;
            border: 1px solid #ccc;
          }`}
      </style>
      <div className="container">
        {isFirst ? <h1 className="h2 text-center">{title}</h1> : <h2 className="text-center">{title}</h2>}
        <h4 class="text-center mt-4">{"Upload a photo of your business card (optional, both sides) to scan and save the contact."}</h4>
        <div className="col-12 col-md-9 col-lg-7 mx-auto mt-4">
          <form className="text-center" onSubmit={handleSubmit(submitImage)}>
            <div className="">
            <label for="img-upload" class="btn custom-file-upload">Choose files {icons.upload}</label>
              <input
                id="img-upload"
                className="d-none"
                type="file"
                multiple
                onChange={handleFileChange}
                required
              />
            </div>
            {imgErrorMessage && <div className="alert alert-light mt-3">{imgErrorMessage}</div>}
            {selectedFiles.length > 0 &&
              <ul className="list-group mt-3">
                {selectedFiles.map((file, index) => (
                  <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="file-list__name">{file.name}</span>
                    <span
                      className="text-danger"
                      style={{cursor:"pointer"}}
                      onClick={() => handleFileRemove(index)}
                    >
                      Remove
                    </span>
                  </li>
                ))}
              </ul>
            }
            <div className="d-flex justify-content-center">
              <div className={"form-check text-start mx-auto mt-4"}>
                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" required/>
                <label className="form-check-label" for="flexCheckChecked"><span className="fs-0875">I agree to the <a href="/terms/">Terms of Service</a>, <a href="/privacy-policy/">Privacy Policy</a> and Use of  Cookies.</span></label>
              </div>
            </div>
            <button type="submit" className={"mt-4 btn btn-sm btn-primary text-uppercase"}>Submit</button>
          </form>
        </div>
      </div>
    </div>
  )
};

export const query = graphql`
  fragment PageDataBodyBusinessCardReader on PrismicPageDataBodyBusinessCardReader {
    primary {
      title
    }
  }
`;
